import QRCode from "qrcode";
import { useState } from "react";
import { Alert, Modal, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./FormularioInscripcion.css";
import { jsPDF } from "jspdf";
import {
  enviaMailInscrito_V3,
  getIdCicletada_V3,
  registroInscripcionOptimizado_V3,
  UpArchivoStorage_V3,
} from "../../firebase/firebase-functions_v3";
import { isValid, useRut } from "react-rut";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRuler } from "@fortawesome/free-solid-svg-icons";
import { ModalTablaTallas } from "./modal/ModalTablaTallas";

export default function FormularioInscripcion() {
  const [telefono, setTelefono] = useState("+56 ");
  const [correo, setCorreo] = useState("");
  const [nombrePac, setNombrePac] = useState("");
  const [apellidoPaterno, setApellidoPaterno] = useState("");
  const [apellidoMaterno, setApellidoMaterno] = useState("");
  const [nombreError, setNombreError] = useState("");
  const [edadError, setEdadError] = useState("");
  const [correoError, setCorreoError] = useState("");
  const [rutError, setRutError] = useState("");
  const [medicamentoError, setMedicamentoError] = useState("");
  const [showModalLoading, setShowModalLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [respuesta, setRespuesta] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const tallas = ["7-8", "11-12", "14-16", "S", "M", "L", "XL", "XXL"];
  const [tallaResponsable, setTallaResponsable] = useState("");
  const [{ formattedValue }, setValidRut] = useRut();
  const [{}, setValidRutAsistente] = useRut();
  const [envioExitoso, setEnvioExitoso] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [mensajeErrorRegistro, setMensajeErrorRegistro] = useState("");
  // Inscripción grabada cuyo correo no salió: { id, pdfBase64 }.
  const [inscripcionSinCorreo, setInscripcionSinCorreo] = useState(null);
  const [showModalTabla, setShowModalTabla] = useState(false);

  const [personas, setPersonas] = useState([
    {
      nombre_asistente: "",
      apellido_paterno_asistente: "",
      apellido_materno_asistente: "",
      rut_asistente: "",
      talla_asistente: "",
      edad_asistente: "",
      polera_entregada: "",
    },
  ]);
  const [edadResponsable, setEdadResponsable] = useState("");

  const handleChange = (e) => {
    setRespuesta(e.target.value);
  };
  const formatRut = (rut) => {
    rut = rut.replace(/[^0-9kK]/g, ""); // solo números y K
    if (rut.length <= 1) return rut;

    let body = rut.slice(0, -1);
    let dv = rut.slice(-1).toUpperCase();

    body = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${body}-${dv}`;
  };
  const validaRut = (rut) => {
    setValidRut(rut);
    if (!isValid(rut)) {
      setRutError("Debe ingresar un rut válido");
    } else {
      setRutError("");
    }
  };

  const faltanDatosAsistentes = personas.some(
    (p) =>
      p.nombre_asistente.trim() === "" ||
      p.apellido_paterno_asistente.trim() === "" ||
      p.apellido_materno_asistente.trim() === "" ||
      p.talla_asistente.trim() === "" ||
      p.edad_asistente === ""||
      p.rut_asistente === ""||
      p.rut_error !== "" // O Number.isNaN(Number(p.edad_asistente)) si quieres validación numérica
  );
  console.log(faltanDatosAsistentes);
  const agregarOtro = () => {
    setPersonas([
      ...personas,
      {
        nombre_asistente: "",
        apellido_paterno_asistente: "",
        apellido_materno_asistente: "",
        rut_asistente: "",
        talla_asistente: "",
        edad_asistente: "",
        polera_entregada: "",
      },
    ]);
  };
  const validarCorreo = (email) => {
    // Expresión regular simple para validar formato de correo
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const actualizarNombre = (index, value) => {
    const nuevasPersonas = [...personas];
    nuevasPersonas[index].nombre_asistente = value;
    setPersonas(nuevasPersonas);
  };
  const actualizarApellidoPaterno = (index, value) => {
    const nuevasPersonas = [...personas];
    nuevasPersonas[index].apellido_paterno_asistente = value;
    setPersonas(nuevasPersonas);
  };
  const actualizarApellidoMaterno = (index, value) => {
    const nuevasPersonas = [...personas];
    nuevasPersonas[index].apellido_materno_asistente = value;
    setPersonas(nuevasPersonas);
  };
  const validaRutAsistente = (index, value) => {
    // Actualiza el estado del hook useRut
    setValidRutAsistente(value);

    // Se guarda en el array de personas con formato
    const nuevasPersonas = [...personas];

    const formatted = formatRut(value);
    nuevasPersonas[index].rut_asistente = formatted;
    // Validación
    if (!isValid(value)) {
      nuevasPersonas[index].rut_error = "Debe ingresar un rut válido";
    } else {
      nuevasPersonas[index].rut_error = "";
    }
    setPersonas(nuevasPersonas);
  };

  const actualizarEdad = (index, value) => {
    const nuevasPersonas = [...personas];
    nuevasPersonas[index].edad_asistente = value;
    setPersonas(nuevasPersonas);
  };
  const actualizarTalla = (index, tallaSeleccionada) => {
    const nuevasPersonas = [...personas];
    nuevasPersonas[index].talla_asistente = tallaSeleccionada;
    setPersonas(nuevasPersonas);
  };
  const generarPDFconQR = async (idInscripcion) => {
    try {
      // 1. Generar imagen QR en base64
      const qrBase64 = await QRCode.toDataURL(idInscripcion);

      // 2. Crear PDF
      const pdf = new jsPDF();

      // Título
      pdf.setFontSize(20);
      pdf.setTextColor("#3e6090"); // color institucional
      pdf.text("10ª Cicletada Familiar por la Epilepsia", 105, 30, {
        align: "center",
      });

      // Fecha del evento
      pdf.setFontSize(14);
      pdf.setTextColor("#e58f2f");
      pdf.text("Domingo 15 de noviembre de 2026", 105, 40, { align: "center" });

      pdf.setFontSize(16);
      pdf.setTextColor("#694b99");
      pdf.text("10:00 hrs", 105, 50, { align: "center" });

      // Imagen QR centrada
      pdf.addImage(qrBase64, "PNG", 60, 55, 90, 90);

      // Mensaje inferior
      pdf.setFontSize(12);
      pdf.setTextColor("#694b99");
      pdf.text("Presenta este QR el día del evento", 105, 155, {
        align: "center",
      });

      // 3. Convertir PDF a base64 (sin encabezado data:)
      const pdfBinary = pdf.output("arraybuffer");
      const pdfBase64 = btoa(
        new Uint8Array(pdfBinary).reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );

      return { pdfBase64, qrBase64 };
    } catch (error) {
      console.error("Error al generar PDF con QR:", error);
      throw error;
    }
  };
  const cleanRutWithoutDV = (rut) => {
    if (!rut) return "";
    // 1. quitar puntos y guion
    const clean = rut.replace(/\./g, "").replace(/-/g, "").trim().toUpperCase();
    // 2. quitar el último carácter (DV)
    return clean.slice(0, -1);
  };
  const enviarInscripcion = async () => {
    let rutResponsable = cleanRutWithoutDV(formattedValue);

    setShowModalLoading(true);
    let objResponsable = {
      nombre_asistente: nombrePac,
      apellido_paterno_asistente: apellidoPaterno,
      apellido_materno_asistente: apellidoMaterno,
      rut_asistente: formattedValue,
      talla_asistente: tallaResponsable,
      edad_asistente: edadResponsable,
      polera_entregada: "",
    };
    let arrAsistentes = [];
    if (respuesta === "Si") {
      arrAsistentes = [...personas, objResponsable];
    } else {
      arrAsistentes.push(objResponsable);
    }
    arrAsistentes = arrAsistentes.map((asistente) => ({
      ...asistente,
      rut_asistente: cleanRutWithoutDV(asistente.rut_asistente),
    }));
    let objInscrito = {
      nombre_responsable: nombrePac,
      apellido_paterno_responsable: apellidoPaterno,
      apellido_materno_responsable: apellidoMaterno,
      rut_responsable: rutResponsable,
      correo_responsable: correo,
      asistentes: arrAsistentes,
      fecha_inscripcion: new Date(),
      id_inscripcion: "",
    };

    // Se guardan fuera del try: si algo falla después de grabar, el catch
    // necesita saber que la inscripción ya existe.
    let idInscripcion = "";
    let pdfInscripcion = "";

    try {
      const response = await registroInscripcionOptimizado_V3(objInscrito);
      console.log(response);

      if (!response.data.creado) {
        mostrarErrorRegistro(response.data.message);
        return;
      }

      idInscripcion = response.data.id;

      // Desde aquí la inscripción ya está grabada: ningún fallo posterior
      // puede dejar al usuario sin su QR ni con el spinner girando.
      const { pdfBase64, qrBase64 } = await generarPDFconQR(idInscripcion);
      pdfInscripcion = pdfBase64;

      let objArchivo = {
        idInscripcion: idInscripcion,
        fecha_inscripcion: new Date(),
        base64: qrBase64,
        type: "image/png",
        fileName: idInscripcion + ".png",
      };

      const subirArchivo = await UpArchivoStorage_V3(objArchivo);

      if (subirArchivo.error) {
        console.log("Error al subir archivo a Firebase Storage");
        console.log(subirArchivo.error);
        finalizarSinCorreo(idInscripcion, pdfBase64);
        return;
      }

      let nombreCompleto =
        nombrePac + " " + apellidoPaterno + " " + apellidoMaterno;
      let objCorreo = {
        nombre_responsable: nombreCompleto,
        correo_responsable: correo,
        imagenQr: pdfBase64,
        id_inscripcion: idInscripcion,
        imagenInscrustada: subirArchivo.data.url,
      };
      const responseCorreo = await enviaMailInscrito_V3(objCorreo);

      if (!responseCorreo.actualizado) {
        console.log("Error al enviar el correo de confirmación");
        finalizarSinCorreo(idInscripcion, pdfBase64);
        return;
      }

      setShowModalLoading(false);
      limpiarFormulario();
      setEnvioExitoso(true);
    } catch (error) {
      console.log("Error al procesar la inscripción");
      console.log(error);

      if (idInscripcion) {
        finalizarSinCorreo(idInscripcion, pdfInscripcion);
        return;
      }

      mostrarErrorRegistro("");
    }
  };
  // La inscripción no se grabó: se muestra el motivo que devolvió la función.
  const mostrarErrorRegistro = (message) => {
    setShowModalLoading(false);
    setMensajeErrorRegistro(
      message || "No se pudo registrar la inscripción. Intenta nuevamente."
    );
    setModalError(true);
  };
  // La inscripción sí quedó grabada pero el correo no salió: se cierra el
  // spinner igual y se le entrega el QR al usuario para descarga directa.
  const finalizarSinCorreo = (id, pdfBase64) => {
    setInscripcionSinCorreo({ id: id, pdfBase64: pdfBase64 });
    setShowModalLoading(false);
    limpiarFormulario();
    setEnvioExitoso(true);
  };
  const descargarQr = () => {
    if (!inscripcionSinCorreo || !inscripcionSinCorreo.pdfBase64) return;

    const enlace = document.createElement("a");
    enlace.href = `data:application/pdf;base64,${inscripcionSinCorreo.pdfBase64}`;
    enlace.download = `${inscripcionSinCorreo.id}.pdf`;
    enlace.click();
  };
  const enviarInscripcionOld = async () => {
    let rutResponsable = cleanRutWithoutDV(formattedValue);

    setShowModalLoading(true);
    let objResponsable = {
      nombre_asistente: nombrePac,
      apellido_paterno_asistente: apellidoPaterno,
      apellido_materno_asistente: apellidoMaterno,
      rut_asistente: formattedValue,
      talla_asistente: tallaResponsable,
      edad_asistente: edadResponsable,
      polera_entregada: "",
    };
    let arrAsistentes = [];
    if (respuesta === "Si") {
      arrAsistentes = [...personas, objResponsable];
    } else {
      arrAsistentes.push(objResponsable);
    }
    arrAsistentes = arrAsistentes.map((asistente) => ({
      ...asistente,
      rut_asistente: cleanRutWithoutDV(asistente.rut_asistente),
    }));
    let objInscrito = {
      nombre_responsable: nombrePac,
      apellido_paterno_responsable: apellidoPaterno,
      apellido_materno_responsable: apellidoMaterno,
      rut_responsable: rutResponsable,
      correo_responsable: correo,
      asistentes: arrAsistentes,
      fecha_inscripcion: new Date(),
      id_inscripcion: "",
    };
    console.log(objInscrito);
    // buscar en registrados si ya existe algun rut registrado
    try {
      const responseId = await getIdCicletada_V3();
      if (responseId.obtenido) {
        objInscrito.id_inscripcion = responseId.id;

        const { pdfBase64, qrBase64 } = await generarPDFconQR(responseId.id);
        let objArchivo = {
          idInscripcion: responseId.id,
          fecha_inscripcion: new Date(),
          base64: qrBase64,
          type: "image/png",
          fileName: responseId.id + ".png",
        };
        const subirArchivo = await UpArchivoStorage_V3(objArchivo);
        console.log(subirArchivo);
        if (subirArchivo.error) {
          console.log("Error al subir archivo a Firebase Storage");
          setShowModalLoading(false);
          setMensaje("Error al subir archivo a Firebase Storage");
          setShowAlert(true);
          return;
        } else {
          objInscrito.url_qr = subirArchivo.data.url;
          try {
            const response = await registroInscripcionOptimizado_V3(objInscrito);
            if (response.data.creado) {
              // subir qr generado a Firebase Storage
              let nombreCompleto =
                nombrePac + " " + apellidoPaterno + " " + apellidoPaterno;
              try {
                let objCorreo = {
                  nombre_responsable: nombreCompleto,
                  correo_responsable: correo,
                  imagenQr: pdfBase64,
                  id_inscripcion: objInscrito.id_inscripcion,
                  imagenInscrustada: subirArchivo.data.url,
                };
                const responseCorreo = await enviaMailInscrito_V3(objCorreo);
                if (responseCorreo.actualizado) {
                  setShowModalLoading(false);
                  limpiarFormulario();
                  setEnvioExitoso(true);
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              setModalError(true);
            }
          } catch (error) {
            console.log("error al grabar en firebase" + error);
          }
        }
      }
      console.log(objInscrito);
    } catch (error) {
      console.log(error);
    }
    // try {
    //   const response = await registrarInscripcion(objInscrito);
    //   console.log(response);
    // } catch (error) {
    //   console.log(error);
    // }
  };
  const limpiarFormulario = () => {
    setNombrePac("");
    setApellidoPaterno("");
    setApellidoMaterno("");
    setValidRut("");
    setEdadResponsable("");
    setCorreo("");
    setTallaResponsable("");
    setRespuesta("");
    setPersonas([
      {
        nombre_asistente: "",
        apellido_paterno_asistente: "",
        apellido_materno_asistente: "",
        rut_asistente: "",
        talla_asistente: "",
        edad_asistente: "",
        polera_entregada: "",
      },
    ]);
  };
  if (envioExitoso && !showModalLoading) {
    return (
      <div className="container d-flex justify-content-center align-items-center mt-5">
        <div className="col-12 col-md-10 col-lg-8 col-xl-6 text-center">
          <h3>Inscripción exitosa</h3>
          <p>
            ¡Gracias por inscribirte a la 10ª Cicletada Familiar por la
            Epilepsia!
          </p>
          {inscripcionSinCorreo ? (
            <>
              <p>
                Tu inscripción quedó registrada con el número{" "}
                <strong>{inscripcionSinCorreo.id}</strong>, pero no pudimos
                enviarte el correo de confirmación. Descarga tu código QR y
                preséntalo el día del evento.
              </p>
              {inscripcionSinCorreo.pdfBase64 ? (
                <div className="mb-3">
                  <button className="boton-inscribir" onClick={descargarQr}>
                    Descargar mi QR
                  </button>
                </div>
              ) : null}
            </>
          ) : (
            <p>
              Hemos enviado un correo electrónico con los detalles de tu
              inscripción y un código QR para presentar el día del evento.
            </p>
          )}
          <a href="/cicletada" rel="noopener noreferrer">
            <button className="boton-ir">Volver al inicio</button>
          </a>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container d-flex justify-content-center align-items-start p-4">
        {modalError ? (
          <Modal
            show={modalError}
            onHide={() => setModalError(false)}
            centered
            backdrop="static"
            keyboard={false}
          >
            <Modal.Header closeButton className="bg-danger text-white">
              <Modal.Title>Error al registrar</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <p>{mensajeErrorRegistro}</p>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="boton"
                variant="danger"
                onClick={() => setModalError(false)}
              >
                Cerrar
              </button>
            </Modal.Footer>
          </Modal>
        ) : null}
        {showModalTabla ? (
          <ModalTablaTallas
            showModalTallas={showModalTabla}
            handleCloseModalTallas={() => setShowModalTabla(false)}
          />
        ) : null}
        {showModalLoading ? (
          <Modal show={showModalLoading} onHide={() => {}} centered>
            <Modal.Body>
              <Spinner
                animation="border"
                style={{ color: "#e58f2f" }}
              ></Spinner>
              <span className="ms-2">Registrando...</span>
            </Modal.Body>
          </Modal>
        ) : (
          <div className="col-12 col-md-10 col-lg-8 col-xl-7">
            <div className="row mb-2">
              <div className="text-center">
                <h3>Inscripción 10ª Cicletada Familiar por la Epilepsia </h3>
              </div>
            </div>
            <div className="alerta-soli" role="alert">
              <span>
                <strong>Cuándo:</strong> Domingo 15 de noviembre de 2026
                <br />
                <strong>Dónde:</strong> Inicio Estación Mapocho (Atrás)
                <br />
                <strong>Horario citación participantes:</strong> 10:00 AM
                {/* <br />
                <strong>Inicio cicletada:</strong> 11:00 AM */}
              </span>
            </div>
            <form>
              <div className="row mt-3">
                <div className="mb-3 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                  <label className="form-label pb-2 ">Ingrese nombre:</label>
                  <input
                    type="text"
                    className={`input-modal ${
                      nombreError ? "input-error" : "input-valido"
                    }`}
                    id="nombre"
                    placeholder="Nombre"
                    value={nombrePac}
                    onChange={(e) => {
                      const capitalized = e.target.value
                        .toLowerCase()
                        .split(" ")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ");
                      setNombrePac(capitalized);
                    }}
                  />
                  {nombreError ? (
                    <p className="mensaje-error">{nombreError}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                  <label className="form-label pb-2 ">
                    Ingrese apellido paterno:
                  </label>
                  <input
                    type="text"
                    className={`input-modal ${
                      nombreError ? "input-error" : "input-valido"
                    }`}
                    id="apellidos"
                    placeholder="Apellido paterno"
                    value={apellidoPaterno}
                    onChange={(e) => {
                      const capitalized = e.target.value
                        .toLowerCase()
                        .split(" ")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ");
                      setApellidoPaterno(capitalized);
                    }}
                  />
                  {nombreError ? (
                    <p className="mensaje-error">{nombreError}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                  <label className="form-label pb-2 ">
                    Ingrese apellido materno:
                  </label>
                  <input
                    type="text"
                    className={`input-modal ${
                      nombreError ? "input-error" : "input-valido"
                    }`}
                    id="apellidos"
                    placeholder="Apellido materno"
                    value={apellidoMaterno}
                    onChange={(e) => {
                      const capitalized = e.target.value
                        .toLowerCase()
                        .split(" ")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ");
                      setApellidoMaterno(capitalized);
                    }}
                  />
                  {nombreError ? (
                    <p className="mensaje-error">{nombreError}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mb-3 col-12 col-sm-12 col-lg-8 col-xl-8">
                  <label className="form-label pb-2">Ingrese su rut:</label>
                  <input
                    type="text"
                    className={`input-modal ${
                      rutError ? "input-error" : "input-valido"
                    }`}
                    id="nombre"
                    placeholder="Rut"
                    maxLength={12}
                    value={formattedValue}
                    onChange={(e) => validaRut(e.target.value)}
                  />
                  {rutError ? <p className="mensaje-error">{rutError}</p> : ""}
                </div>
                <div className="mb-3 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                  <label className="form-label pb-2 ">Ingrese edad:</label>
                  <input
                    type="number"
                    className={`input-modal ${
                      nombreError ? "input-error" : "input-valido"
                    }`}
                    id="edad"
                    placeholder="Edad"
                    value={edadResponsable}
                    onChange={(value) => setEdadResponsable(value.target.value)}
                  />
                  {edadError ? (
                    <p className="mensaje-error">{edadError}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-12 col-sm-12 col-lg-12 col-xl-12 ">
                  <label className="form-label pb-2">Ingrese su email:</label>
                  <input
                    type="email"
                    className={`input-modal ${
                      correoError ? "input-error" : "input-valido"
                    }`}
                    id="email"
                    placeholder="Correo"
                    value={correo}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setCorreo(valor);

                      if (!validarCorreo(valor)) {
                        setCorreoError("Formato de correo inválido");
                      } else {
                        setCorreoError("");
                      }
                    }}
                  />
                  {correoError ? (
                    <p className="mensaje-error">{correoError}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row">
                <div className="mb-4 col-12">
                  <label className="form-label pb-2">
                    Seleccione talla polera
                  </label>
                  <span
                    className="text-primary ps-3"
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => setShowModalTabla(true)}
                  >
                    <FontAwesomeIcon icon={faRuler} className="me-2" />
                    Ver tabla de tallas
                  </span>
                  {tallas.map((talla, index) => (
                    <div className="form-check" key={index}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="tallaSeleccionado"
                        id={`radio-${index}`}
                        value={talla}
                        onChange={(e) => setTallaResponsable(e.target.value)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`radio-${index}`}
                      >
                        {talla}
                      </label>
                    </div>
                  ))}
                  {medicamentoError && (
                    <p className="mensaje-error">{medicamentoError}</p>
                  )}
                </div>
              </div>
              <div className="mb-3">
                <div className="mb-4 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <label className="form-label pb-2">
                    ¿Va con acompañantes?
                  </label>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="radioDefault"
                      id="radioDefault1"
                      onChange={handleChange}
                      value="Si"
                      checked={respuesta === "Si"}
                    />
                    <label class="form-check-label" for="radioDefault1">
                      Si
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="radioDefault"
                      id="radioDefault2"
                      onChange={handleChange}
                      value="No"
                      checked={respuesta === "No"}
                    />
                    <label class="form-check-label" for="radioDefault2">
                      No
                    </label>
                  </div>
                  {medicamentoError ? (
                    <p className="mensaje-error">{medicamentoError}</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {respuesta === "Si"
                ? personas.map((persona, index) => (
                    <div key={index}>
                      <div className="row">
                        <div className="mb-3 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                          <label className="form-label pb-2">
                            Ingrese nombre:
                          </label>
                          <input
                            type="text"
                            className={`input-modal ${
                              nombreError ? "input-error" : "input-valido"
                            }`}
                            placeholder="Nombre"
                            value={persona.nombre_asistente}
                            onChange={(e) => {
                              const capitalized = e.target.value
                                .toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ");

                              actualizarNombre(index, capitalized);
                            }}
                          />
                        </div>
                        <div className="mb-3 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                          <label className="form-label pb-2">
                            Ingrese apellido paterno:
                          </label>
                          <input
                            type="text"
                            className={`input-modal ${
                              nombreError ? "input-error" : "input-valido"
                            }`}
                            placeholder="Apellido paterno"
                            value={persona.apellido_paterno_asistente}
                            onChange={(e) => {
                              const capitalized = e.target.value
                                .toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ");

                              actualizarApellidoPaterno(index, capitalized);
                            }}
                          />
                        </div>
                        <div className="mb-3 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                          <label className="form-label pb-2">
                            Ingrese apellido materno:
                          </label>
                          <input
                            type="text"
                            className={`input-modal ${
                              nombreError ? "input-error" : "input-valido"
                            }`}
                            placeholder="Apellido materno"
                            value={persona.apellido_materno_asistente}
                            onChange={(e) => {
                              const capitalized = e.target.value
                                .toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ");

                              actualizarApellidoMaterno(index, capitalized);
                            }}
                          />
                        </div>
                        <div className="mb-3 col-12 col-sm-12 col-lg-7 col-xl-7">
                          <label className="form-label pb-2">
                            Ingrese rut:
                          </label>
                          <input
                            type="text"
                            className={`input-modal ${
                              rutError ? "input-error" : "input-valido"
                            }`}
                            placeholder="Rut"
                            maxLength={12}
                            value={persona.rut_asistente}
                            onChange={(e) =>
                              validaRutAsistente(index, e.target.value)
                            }
                          />
                          {persona.rut_error && (
                            <p className="mensaje-error">{persona.rut_error}</p>
                          )}
                        </div>
                        <div className="mb-3 col-12 col-sm-12 col-lg-5 col-xl-5">
                          <label className="form-label pb-2">
                            Ingrese edad:
                          </label>
                          <input
                            type="number"
                            className={`input-modal ${
                              nombreError ? "input-error" : "input-valido"
                            }`}
                            placeholder="Edad"
                            value={persona.edad_asistente}
                            onChange={(e) =>
                              actualizarEdad(index, e.target.value)
                            }
                          />
                        </div>
                        <div className="mb-3 col-12 d-flex align-items-end justify-content-center">
                          <button
                            type="button"
                            className="boton-mas"
                            onClick={agregarOtro}
                            disabled={personas.length >= 10}
                          >
                            +
                          </button>
                        </div>
                      </div>

                      <div className="row">
                        <div className="mb-4 col-12">
                          <label className="form-label pb-2">
                            Seleccione talla polera
                          </label>
                          <span
                            className="text-primary ps-3"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setShowModalTabla(true)}
                          >
                            <FontAwesomeIcon icon={faRuler} className="me-2" />
                            Ver tabla de tallas
                          </span>
                          {tallas.map((talla, tIndex) => (
                            <div className="form-check" key={tIndex}>
                              <input
                                className="form-check-input"
                                type="radio"
                                name={`talla-${index}`}
                                id={`radio-${index}-${tIndex}`}
                                value={talla}
                                checked={persona.talla_asistente === talla}
                                onChange={() => actualizarTalla(index, talla)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`radio-${index}-${tIndex}`}
                              >
                                {talla}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))
                : null}
            </form>{" "}
            <div className="mb-2 pt-3 text-center">
              <Alert
                variant="warning"
                className="alerta-modal"
                show={showAlert}
              >
                <p>{mensaje}</p>
              </Alert>
              <button
                className="boton-inscribir"
                onClick={() => enviarInscripcion()}
                disabled={
                  nombrePac === "" ||
                  apellidoMaterno === "" ||
                  apellidoPaterno === "" ||
                  formattedValue === "" ||
                  edadResponsable === "" ||
                  correo === "" ||
                  tallaResponsable === "" ||
                  respuesta === "" ||
                  (respuesta === "Si" && faltanDatosAsistentes)
                    ? true
                    : false
                }
              >
                Inscribirse
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
